import { Link } from "react-router-dom";
import { ArrowUpRight, Target, ClipboardList, Newspaper, Quote, CalendarDays, BookOpen, PieChart, Phone, HelpCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PAGES = [
  { to: "/#about", icon: Target, num: "01", title: "The project", desc: "Start here — what this research is and why I'm doing it" },
  { to: "/#survey", icon: ClipboardList, num: "02", title: "The survey", desc: "Tell the full story in 2 minutes, anonymously" },
  { to: "/#news", icon: Newspaper, num: "03", title: "Headlines", desc: "What's happening in football around Morbi" },
  { to: "/#voices", icon: Quote, num: "04", title: "Voices", desc: "Healthy quotes from teens, parents and coaches" },
  { to: "/big-games", icon: CalendarDays, num: "05", title: "Big games & tables", desc: "Fixtures, tournaments, the points table and top stats" },
  { to: "/quiz", icon: HelpCircle, num: "06", title: "Daily quiz", desc: "10 questions for every age — top the leaderboard" },
  { to: "/research", icon: BookOpen, num: "07", title: "Research", desc: "My written blogs — the story behind the numbers" },
  { to: "/results", icon: PieChart, num: "08", title: "Results", desc: "The findings so far, as live charts" },
  { to: "/talk-to-us", icon: Phone, num: "09", title: "Talk to us", desc: "My number, email and socials — say hello" },
];

const SitemapSection = () => (
  <section id="sitemap" className="relative py-16 md:py-24" data-testid="sitemap-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow>Site map</Eyebrow>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
          New here? <span className="font-serif italic font-medium marker-highlight">Read it in this order</span>
        </h2>
        <p className="mt-3 text-muted-foreground max-w-2xl">
          The whole website, arranged as a journey: learn what it is, have your say, follow the
          local game, read the findings, then get in touch.
        </p>
      </Reveal>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PAGES.map((p, idx) => (
          <Reveal key={p.to + p.title} delay={0.04 * Math.min(idx, 6)}>
            <Link
              to={p.to}
              data-testid={`sitemap-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group flex flex-col rounded-3xl bg-card border border-foreground/10 p-5 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all h-full"
            >
              <span className="flex items-center justify-between">
                <span className="font-mono text-xs text-flame">{p.num}</span>
                <p.icon className="h-5 w-5 text-pitch dark:text-turf" />
              </span>
              <span className="mt-3 flex items-center gap-2 font-display font-bold text-base sm:text-lg tracking-tight">
                {p.title}
                <ArrowUpRight className="h-4 w-4 text-flame opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all" />
              </span>
              <span className="block mt-1 text-sm text-muted-foreground leading-snug">{p.desc}</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default SitemapSection;
